import { render, staticRenderFns } from "./FixedBar.vue?vue&type=template&id=5b5029bf&scoped=true"
import script from "./FixedBar.vue?vue&type=script&lang=js"
export * from "./FixedBar.vue?vue&type=script&lang=js"
import style0 from "./FixedBar.vue?vue&type=style&index=0&id=5b5029bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5029bf",
  null
  
)

export default component.exports